import React from "react";
import { useAmplitude } from "react-amplitude-hooks";
import styled from "@emotion/styled";
import { ButtonText } from "style/components/pc";

interface DefinitionLineProps {
  title: string;
  content: any;
  more?: boolean;
  showPopup?: any;
  noBreak?: boolean;
  plainType?: boolean;
  className?: string;
}

const DefinitionLine: React.FC<DefinitionLineProps> = ({
  title,
  content,
  more,
  showPopup,
  noBreak,
  plainType,
  className
}) => {
  const { logEvent } = useAmplitude();

  return (
    <Definition
      className={`${className ? className : ""} ${noBreak ? "noBreak" : ""} ${
        plainType ? "plainType" : ""
      }`}
    >
      <dt>{title}</dt>
      <dd>
        <span>{content}</span>
        {more && (
          <ButtonText
            type="button"
            onClick={() => {
              logEvent("plan_info_button");
              showPopup();
            }}
          >
            보장내용
          </ButtonText>
        )}
      </dd>
    </Definition>
  );
};

export default DefinitionLine;

const Definition = styled.dl`
  display: flex;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: ${props => props.theme.text.sizeFontS};

  &.noBreak dd {
    white-space: nowrap;
  }

  &.first {
    margin-top: 0;
  }

  > dt {
    width: 100px;
    font-weight: ${props => props.theme.weight.bold};
  }

  > dd {
    display: flex;
    flex: 1;
    justify-content: space-between;
    aling-items: center;
    word-break: break-all;
  }

  .popupButton {
    flex: 50px 0 0;
    text-align: right;
  }

  &.plainType {
    padding-top: 2px;
    padding-bottom: 2px;
    justify-content: flex-start;
    font-size: ${props => props.theme.text.sizeFont};

    dt {
      width: auto;
      font-weight: ${props => props.theme.weight.normal};

      &::after {
        content: " : ";
        margin-right: 4px;
      }
    }
  }

  &.partnerList {
    padding-top: 6px;
    dd > span {
      display: block;
      width: 100%;
    }
  }
`;
